module.exports = __webpack_public_path__ + "static/media/bearbuddies.6df54bc1.png";